<template>
  <DBox :id="'cmp-settings-label-format'" :addButton="false" :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('format')}`" @add_click="onAddFormat">
    <NTable id="settings-label-statuses-table" class="h1" :config="tableConfig" :headers="headers" :items="formats"
      :showNoItems="false">
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('format')">
            <span class="txtov" style="font-weight: 600;" :title="item['format_name']"
              @click="(e) => onFormatClick(item)">
              {{ item["format_name"] }}
            </span>
          </td>
          <td v-bind="tdcon('album')">
            <span class="txtov" :title="item['album_single_merch']">
              {{ $t(item["album_single_merch"]) }}
            </span>
          </td>
          <td v-bind="tdcon('channel')">
           
            <div style="padding-top:5px;">
              <img v-if="item['channel'] == 'digital'" src="static/icons/royalty/icon-digital.svg" class="dt-icon v5 s2"
                alt="Digital" title="Digital" />

              <img v-if="item['channel'] == 'physical'" src="static/icons/royalty/icon-physical.svg" class="dt-icon v5 s2"
                alt="Physical" title="Physical" />
          </div>
          </td>
          <td v-bind="tdcon('group')">
            <TextField2 class="dbox1" :id="'format_group'" :showLabel="false" :value="item['format_group']"
              @blur="(e) => onTextFieldValueChange(e, item)" />
          </td>
          <td v-bind="tdcon('options')">
            <img v-if="item['deletable'] == '1'" src="static/icons/delete.svg" @click="(e) => onDeleteFormat(item)"
              class="dt-icon v5 s1" :alt="$t('delete_format')" :title="$t('delete_format')" />
          </td>
        </tr>
      </template>
    </NTable>

  </DBox>
</template>
<script>
import DBox from "@dtplugins/dbox/dbox";
import ColorPicker from "@plugins/color-picker/color-picker";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createTableHeader, createNTableConfig } from "../../../../plugins/datatable";

export default {
  components: {
    DBox,
    ColorPicker,
  },
  props: {
    formats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        rowHeight: 32,
      });
    },
    headers() {
      return [
        createTableHeader("format"),
        createTableHeader("album"),
        createTableHeader("channel", { mw: 80, ta: "center" }),
        createTableHeader("group",),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    onAddFormat: function () {
      this.$emit("add_click", true);
    },
    onTextFieldValueChange: function ({ name, value }, item) {

      this.$emit("changed", {
        name, value, item:item
      });
    },

    onDeleteFormat: async function (item) {
      this.$emit("deleted", item);
    },
    onColorPickerChange: function (label_status, value) {
      this.$emit("color_changed", {
        ...label_status,
        label_status_colour: value.hex.slice(1),
      });
    },
    onFormatClick: function (item) {
      this.$emit("selected", item);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-label-format {}
</style>
